import React from 'react';
import WebGlSupportWarning from './WebGlSupportWarning';

class MapErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) return <WebGlSupportWarning />;
    return this.props.children;
  }
}

export default MapErrorBoundary;
